import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Divider, Button, Tabs, Typography, Spin, Drawer, Tag, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Cookies } from 'react-cookie';
import axios from 'axios';
import dayjs from 'dayjs';
const cookies = new Cookies();
var token = cookies.get('token');
const { Text, Link } = Typography;

const mapStoreToProps = (store) => {
    return {
    };
};

class AtmeLists extends Component {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
    }

    state = {
        show: false,
        processed_data: [],
        atme_data: [],
        noread_data: [],
        loading: false,
        activeTab: '1',
        noread_next_page: null,
        processed_next_page: null,
        atme_next_page: null,
        noread_loaded: false,
        processed_loaded: false,
        atme_loaded: false,
        deadlineFilterByTab: {
            '1': 'all',
            '3': 'all',
        },
        overview_loading: false,
        overview_counts: {
            pendingSoon: 0,
            pendingOverdue: 0,
            atmeSoon: 0,
            atmeOverdue: 0,
        },
    }

    componentDidMount() {
        this.props.onRef(this);
        // this.showModal();
    }

    showModal = () => {
        // localStorage.removeItem('atme_message_count');
        localStorage.setItem('atme_message_count', this.props.atme_message_count);
        this.fetchAtmeNoRead();
        this.fetchDeadlineOverview();
        this.setState({
            show: true,
            activeTab: '1',
            processed_data: [],
            atme_data: [],
            processed_next_page: null,
            atme_next_page: null,
            processed_loaded: false,
            atme_loaded: false,
        });
    }

    getDeadlineValue = (item) => {
        if (!item) {
            return null;
        }
        return item.deadline || item.dead_line || item.deadLine || item.due_date || item.dueDate || null;
    }

    getDeadlineAlert = (item) => {
        const deadline = this.getDeadlineValue(item);
        if (!deadline) {
            return null;
        }
        const dueDate = dayjs(deadline);
        if (!dueDate.isValid()) {
            return null;
        }
        const daysLeft = dueDate.startOf('day').diff(dayjs().startOf('day'), 'day');
        if (daysLeft < 0) {
            return {
                color: 'red',
                textColor: '#ff4d4f',
                label: '已过期',
                deadline: dueDate.format('YYYY-MM-DD'),
            };
        }
        if (daysLeft <= 2) {
            return {
                color: 'orange',
                textColor: '#faad14',
                label: `剩${daysLeft}天到期`,
                deadline: dueDate.format('YYYY-MM-DD'),
            };
        }
        return {
            color: null,
            textColor: '#91d5ff',
            label: '',
            deadline: dueDate.format('YYYY-MM-DD'),
        };
    }

    isHandledMessage = (item) => {
        if (!item) {
            return false;
        }
        const relationStatus = item.relation_description ?? item.description;
        return item.status === false || item.status === 0 || item.status === '0' || relationStatus === 1 || relationStatus === '1';
    }

    renderFormattedText = (text) => {
        if (text === null || text === undefined || text === '') {
            return null;
        }

        return String(text).split(/<br\s*\/?>|\r\n|\r|\n/gi).map((part, index) => (
            <React.Fragment key={index}>
                {index > 0 ? <br /> : null}
                {part}
            </React.Fragment>
        ));
    }

    changeDeadlineFilter = (tabKey, filter) => {
        this.setState((prevState) => ({
            deadlineFilterByTab: {
                ...prevState.deadlineFilterByTab,
                [tabKey]: filter,
            },
        }), () => {
            if (tabKey === '1') {
                this.fetchAtmeNoRead(1, false);
            }
            if (tabKey === '3') {
                this.fetchAtMeMessage(1, false);
            }
        });
    }

    jumpToTabWithFilter = (tabKey, filter) => {
        this.setState((prevState) => ({
            activeTab: tabKey,
            deadlineFilterByTab: {
                ...prevState.deadlineFilterByTab,
                [tabKey]: filter,
            },
        }), () => {
            if (tabKey === '1') {
                this.fetchAtmeNoRead(1, false);
            }
            if (tabKey === '3') {
                this.fetchAtMeMessage(1, false);
            }
        });
    }

    renderDeadlineFilter = (tabKey) => {
        const activeFilter = (this.state.deadlineFilterByTab && this.state.deadlineFilterByTab[tabKey]) || 'all';
        return (
            <div style={{ marginBottom: '10px' }}>
                <Space size={8} wrap>
                    <Button size="small" type={activeFilter === 'all' ? 'primary' : 'default'} onClick={() => this.changeDeadlineFilter(tabKey, 'all')}>全部</Button>
                    <Button size="small" type={activeFilter === 'overdue' ? 'primary' : 'default'} onClick={() => this.changeDeadlineFilter(tabKey, 'overdue')}>已过期</Button>
                    <Button size="small" type={activeFilter === 'soon' ? 'primary' : 'default'} onClick={() => this.changeDeadlineFilter(tabKey, 'soon')}>2天内到期</Button>
                </Space>
            </div>
        );
    }

    getNextPageFromUrl = (nextPageUrl) => {
        if (!nextPageUrl) {
            return null;
        }
        const matched = nextPageUrl.match(/[?&]page=(\d+)/);
        if (!matched) {
            return null;
        }
        const pageNum = parseInt(matched[1], 10);
        return Number.isNaN(pageNum) ? null : pageNum;
    }

    normalizePagedResponse = (response) => {
        const dataNode = response?.data?.data;
        if (Array.isArray(dataNode)) {
            return {
                items: dataNode,
                nextPage: null,
                total: dataNode.length,
            };
        }
        if (dataNode && Array.isArray(dataNode.data)) {
            const parsedTotal = parseInt(dataNode.total, 10);
            return {
                items: dataNode.data,
                nextPage: this.getNextPageFromUrl(dataNode.next_page_url),
                total: Number.isNaN(parsedTotal) ? dataNode.data.length : parsedTotal,
            };
        }
        return {
            items: [],
            nextPage: null,
            total: 0,
        };
    }

    buildFetchUrl = (tabKey, page = 1, deadlineFilterOverride = null) => {
        const deadlineFilter = deadlineFilterOverride || ((this.state.deadlineFilterByTab && this.state.deadlineFilterByTab[tabKey]) || 'all');
        const deadlineFilterQuery = (tabKey === '1' || tabKey === '3') && deadlineFilter !== 'all'
            ? `&deadline_filter=${deadlineFilter}`
            : '';

        if (tabKey === '1') {
            return `${window.api}admin/fetchAtme?page=${page}&no_read=1${deadlineFilterQuery}&token=${token}`;
        }
        if (tabKey === '2') {
            return `${window.api}admin/fetchAtme?page=${page}&token=${token}`;
        }
        return `${window.api}admin/fetchAtMeMessage?page=${page}${deadlineFilterQuery}&token=${token}`;
    }

    fetchDeadlineOverview = () => {
        this.setState({ overview_loading: true });
        axios.get(window.api + 'admin/fetchAtmeDeadlineSummary?token=' + token)
            .then((response) => {
                const summary = response?.data?.data || {};
                const toCount = (...values) => {
                    for (let i = 0; i < values.length; i += 1) {
                        const parsed = parseInt(values[i], 10);
                        if (!Number.isNaN(parsed)) {
                            return parsed;
                        }
                    }
                    return 0;
                };

                const pendingSoon = toCount(
                    summary.pending_deadline_soon_count,
                    summary.pending_soon_count,
                    summary.initiated_deadline_soon_count,
                    summary.initiated_soon_count,
                    summary.noread_deadline_soon_count,
                    summary.noread_soon_count,
                    summary.pending?.deadline_soon_count,
                    summary.pending?.soon_count,
                    summary.initiated?.deadline_soon_count,
                    summary.initiated?.soon_count,
                );
                const pendingOverdue = toCount(
                    summary.pending_deadline_overdue_count,
                    summary.pending_overdue_count,
                    summary.initiated_deadline_overdue_count,
                    summary.initiated_overdue_count,
                    summary.noread_deadline_overdue_count,
                    summary.noread_overdue_count,
                    summary.pending?.deadline_overdue_count,
                    summary.pending?.overdue_count,
                    summary.initiated?.deadline_overdue_count,
                    summary.initiated?.overdue_count,
                );
                const atmeSoon = toCount(
                    summary.atme_deadline_soon_count,
                    summary.atme_soon_count,
                    summary.mention_deadline_soon_count,
                    summary.mention_soon_count,
                    summary.atme?.deadline_soon_count,
                    summary.atme?.soon_count,
                    summary.mention?.deadline_soon_count,
                    summary.mention?.soon_count,
                    summary.deadline_soon_count,
                    summary.soon_count,
                );
                const atmeOverdue = toCount(
                    summary.atme_deadline_overdue_count,
                    summary.atme_overdue_count,
                    summary.mention_deadline_overdue_count,
                    summary.mention_overdue_count,
                    summary.atme?.deadline_overdue_count,
                    summary.atme?.overdue_count,
                    summary.mention?.deadline_overdue_count,
                    summary.mention?.overdue_count,
                    summary.deadline_overdue_count,
                    summary.overdue_count,
                );

                this.setState({
                    overview_counts: {
                        pendingSoon,
                        pendingOverdue,
                        atmeSoon,
                        atmeOverdue,
                    },
                    overview_loading: false,
                });
            })
            .catch(() => {
                this.setState({ overview_loading: false });
            });
    }

    fetchTabData = (tabKey, page = 1, append = false) => {
        this.setState({ loading: true });
        axios.get(this.buildFetchUrl(tabKey, page))
            .then((response) => {
                const { items, nextPage } = this.normalizePagedResponse(response);
                this.setState((prevState) => {
                    if (tabKey === '1') {
                        return {
                            noread_data: append ? prevState.noread_data.concat(items) : items,
                            noread_next_page: nextPage,
                            noread_loaded: true,
                            loading: false,
                        };
                    }
                    if (tabKey === '2') {
                        return {
                            processed_data: append ? prevState.processed_data.concat(items) : items,
                            processed_next_page: nextPage,
                            processed_loaded: true,
                            loading: false,
                        };
                    }
                    return {
                        atme_data: append ? prevState.atme_data.concat(items) : items,
                        atme_next_page: nextPage,
                        atme_loaded: true,
                        loading: false,
                    };
                });
            })
            .catch((error) => {
                this.setState({ loading: false });
            });
    }

    renderPaginationFooter = (tabKey, nextPage, loaded) => {
        if (nextPage) {
            return (
                <div className="text-center">
                    <Button
                        onClick={() => this.loadMore(tabKey)}
                        shape="round"
                        loading={this.state.loading}
                    >
                        {'加载更多'}
                    </Button>
                    <br />
                    <br />
                    <br />
                </div>
            );
        }

        if (nextPage === null && loaded) {
            return (
                <div className="text-center">
                    <p>{'所有数据已加载完毕'}</p>
                    <br />
                    <br />
                    <br />
                </div>
            );
        }

        return null;
    }

    renderDeadlineOverview = () => {
        const { overview_counts, overview_loading } = this.state;
        return (
            <div style={{ marginBottom: '12px', padding: '10px 12px', border: '1px solid rgba(91, 192, 222, 0.45)', borderRadius: '6px', background: 'rgba(91, 192, 222, 0.12)' }}>
                <Spin spinning={overview_loading} size="small">
                    <div style={{ fontSize: '12px', color: '#5bc0de', marginBottom: '8px' }}>截止提醒汇总</div>
                    <div style={{ fontSize: '12px', marginBottom: '6px' }}>
                        <span style={{ color: '#FFF' }}>发起待处理</span>
                        <Tag color="orange" style={{ marginLeft: '8px', cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('1', 'soon')}>即将 {overview_counts.pendingSoon}</Tag>
                        <Tag color="red" style={{ cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('1', 'overdue')}>已过期 {overview_counts.pendingOverdue}</Tag>
                    </div>
                    <div style={{ fontSize: '12px' }}>
                        <span style={{ color: '#FFF' }}>@我</span>
                        <Tag color="orange" style={{ marginLeft: '35px', cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('3', 'soon')}>即将 {overview_counts.atmeSoon}</Tag>
                        <Tag color="red" style={{ cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('3', 'overdue')}>已过期 {overview_counts.atmeOverdue}</Tag>
                    </div>
                </Spin>
            </div>
        );
    }

    fetchAtmeNoRead = (page = 1, append = false) => {
        this.fetchTabData('1', page, append);
    }

    loadMore = (tabKey) => {
        if (tabKey === '1' && this.state.noread_next_page) {
            this.fetchAtmeNoRead(this.state.noread_next_page, true);
            return;
        }
        if (tabKey === '2' && this.state.processed_next_page) {
            this.fetchAtme(this.state.processed_next_page, true);
            return;
        }
        if (tabKey === '3' && this.state.atme_next_page) {
            this.fetchAtMeMessage(this.state.atme_next_page, true);
        }
    };

    fetchAtme = (page = 1, append = false) => {
        this.fetchTabData('2', page, append);
    }

    fetchAtMeMessage = (page = 1, append = false) => {
        this.fetchTabData('3', page, append);
    }

    handleCancel = () => {
        this.setState({
            show: false,
        });
    }

    onChangeTab = (key) => {
        this.setState({ activeTab: key });
        if (key === '2' && !this.state.processed_loaded) {
            this.fetchAtme();
        }
        if (key === '3' && !this.state.atme_loaded) {
            this.fetchAtMeMessage();
        }
    }

    render() {
        return (
            <>
                <Drawer
                    destroyOnClose
                    title="留言"
                    placement="right"
                    closable={false}
                    open={this.state.show}
                    onClose={this.handleCancel}
                    width={'460px'}
                >
                    {/* <Modal
                    open={this.state.show}
                    title={`我的留言`}
                    onOk={(e) => { }}
                    onCancel={this.handleCancel}
                    footer={[
                    ]}> */}
                    {this.renderDeadlineOverview()}
                    <Tabs size="small" tabBarGutter={8} activeKey={this.state.activeTab} onChange={this.onChangeTab} items={[{
                        key: '1',
                        label: '发起待处理',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>
                            {this.renderDeadlineFilter('1')}
                            {this.state.noread_data.map((e) => {
                                const deadlineAlert = this.getDeadlineAlert(e);
                                const isHandled = this.isHandledMessage(e);
                                return (
                                    <>
                                        <Row>
                                            <Col>
                                                <Text style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }} delete={e.status ? false : true}>{this.renderFormattedText(e.message)}</Text>
                                                <br />
                                                <span style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }}>
                                                    <Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>
                                                        {this.renderFormattedText(e.notices)}
                                                        {deadlineAlert ? (
                                                            <>
                                                                <br />
                                                                <span style={{ color: '#91d5ff' }}>截止日期: {deadlineAlert.deadline}</span>
                                                                {!isHandled && deadlineAlert.color ? <Tag style={{ marginLeft: '6px' }} color={deadlineAlert.color}>{deadlineAlert.label}</Tag> : null}
                                                            </>
                                                        ) : null}
                                                        <br />
                                                        <span style={{ fontSize: '10px', color: '#5bc0de' }}>{e.user_name}</span> - <span style={{ fontSize: '10px' }}>{e.created_at}</span>
                                                    </Text>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '0px', fontSize: '12px' }}>
                                            <Col span={24}>
                                                <Divider orientation="right" style={{ margin: '0', fontSize: '10px', color: e.status ? '#FFF' : 'gray' }}><Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>来源 &nbsp;
                                                    {
                                                        <>
                                                            {((e.type == 'home') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href='/todolist'>AOI留言</a>
                                                                : null)}

                                                            {((e.type == 'order') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/order/${e.table_1}`}>Order</a>
                                                                : null)}

                                                            {((e.type == 'invoice') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/invoice/${e.table_1}`}>Invoice</a>
                                                                : null)}

                                                            {((e.type == 'inquiry') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/inquiry/${e.table_1}`}>Inquiry</a>
                                                                : null)}
                                                        </>
                                                    }
                                                </Text>
                                                </Divider>
                                            </Col>
                                        </Row>
                                    </>)
                            })}
                            {(this.state.noread_data.length === 0 && this.state.noread_loaded) ? <p style={{ color: '#bbb', marginBottom: '12px' }}>当前筛选下没有留言</p> : null}

                            {this.renderPaginationFooter('1', this.state.noread_next_page, this.state.noread_loaded)}
                        </>,
                    },
                    {
                        key: '2',
                        label: '发起已处理',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>

                            {this.state.processed_data.map((e) => {
                                return (
                                    <>
                                        <Row>
                                            <Col>
                                                <Text style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }} delete={e.status ? false : true}>{this.renderFormattedText(e.message)}</Text>
                                                <br />
                                                <span style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }}>
                                                    <Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>
                                                        {this.renderFormattedText(e.notices)}
                                                        <br />
                                                        处理时间:{e.updated_at}
                                                    </Text>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '0px', fontSize: '12px' }}>
                                            <Col span={24}>
                                                <Divider orientation="right" style={{ margin: '0', fontSize: '10px', color: e.status ? '#FFF' : 'gray' }}><Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>来源 &nbsp;
                                                    {
                                                        <>
                                                            {((e.type == 'home') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href='/todolist'>AOI留言</a>
                                                                : null)}

                                                            {((e.type == 'order') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/order/${e.table_1}`}>Order</a>
                                                                : null)}

                                                            {((e.type == 'invoice') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/invoice/${e.table_1}`}>Invoice</a>
                                                                : null)}

                                                            {((e.type == 'inquiry') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/inquiry/${e.table_1}`}>Inquiry</a>
                                                                : null)}
                                                        </>
                                                    }
                                                </Text>
                                                </Divider>
                                            </Col>
                                        </Row>
                                    </>)
                            })}
                            {(this.state.processed_data.length === 0 && this.state.processed_loaded) ? <p style={{ color: '#bbb', marginBottom: '12px' }}>没有已处理留言</p> : null}
                            {this.renderPaginationFooter('2', this.state.processed_next_page, this.state.processed_loaded)}
                        </>,
                    },
                    {
                        key: '3',
                        label: '@我',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>
                            {this.renderDeadlineFilter('3')}

                            {this.state.atme_data.map((e) => {
                                const deadlineAlert = this.getDeadlineAlert(e);
                                const isHandled = this.isHandledMessage(e);
                                return (
                                    <>
                                        <Row>
                                            <Col>
                                                <Text style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }} delete={e.status ? false : true}>{this.renderFormattedText(e.message)}</Text>
                                                <br />
                                                <span style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }}>
                                                    <Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>
                                                        {this.renderFormattedText(e.notices)}
                                                        {deadlineAlert ? (
                                                            <>
                                                                <br />
                                                                <span style={{ color: '#91d5ff' }}>截止日期: {deadlineAlert.deadline}</span>
                                                                {!isHandled && deadlineAlert.color ? <Tag style={{ marginLeft: '6px' }} color={deadlineAlert.color}>{deadlineAlert.label}</Tag> : null}
                                                            </>
                                                        ) : null}
                                                        <br />
                                                        <span style={{ fontSize: '10px', color: '#5bc0de' }}>{e.user_name}</span> - <span style={{ fontSize: '10px' }}>{e.created_at}</span>
                                                    </Text>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '0px', fontSize: '12px' }}>
                                            <Col span={24}>
                                                <Divider orientation="right" style={{ margin: '0', fontSize: '10px', color: e.status ? '#FFF' : 'gray' }}><Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>来源 &nbsp;
                                                    {
                                                        <>
                                                            {((e.type == 'home') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href='/todolist'>AOI留言</a>
                                                                : null)}

                                                            {((e.type == 'order') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/order/${e.table_1}`}>Order</a>
                                                                : null)}

                                                            {((e.type == 'invoice') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/invoice/${e.table_1}`}>Invoice</a>
                                                                : null)}

                                                            {((e.type == 'inquiry') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/inquiry/${e.table_1}`}>Inquiry</a>
                                                                : null)}
                                                        </>
                                                    }
                                                </Text>
                                                </Divider>
                                            </Col>
                                        </Row>
                                    </>)
                            })}
                            {(this.state.atme_data.length === 0 && this.state.atme_loaded) ? <p style={{ color: '#bbb', marginBottom: '12px' }}>当前筛选下没有留言</p> : null}
                            {this.renderPaginationFooter('3', this.state.atme_next_page, this.state.atme_loaded)}
                        </>,
                    }]} />
                </Drawer>
            </>
        );
    }
}

export default connect(mapStoreToProps)(AtmeLists);
